import {useEffect} from 'react';
import moment from 'moment';
import {mergeDateWithTime} from '@utils/tools/time';

type UseAutoEndTimeProps = {
    duration: number | undefined;
    startTime: string | undefined;
    setValue: (name: string, value: any, options?: any) => void;
    referenceDate?: string;
};

export const useAutoEndTime = ({duration, startTime, setValue, referenceDate}: UseAutoEndTimeProps) => {
    useEffect(() => {
        if (!duration || !startTime) return;

        const start = moment(startTime);
        const end = moment(start).add(duration, 'minutes');

        const endTime = referenceDate ? mergeDateWithTime(end.format(), referenceDate) : end.format();

        setValue('endTime', endTime, {shouldDirty: false});
    }, [duration, startTime, setValue, referenceDate]);
};
